import { Inject, Injectable } from '@angular/core';
import { FirebaseApp } from 'firebase/app';
import { ToastrService } from 'ngx-toastr';
import { CommonFireStoreDao, QueryParam } from '../dao/CommonFireStoreDao.dao';
import { FIREBASE_APP } from '../injections/firebase-app';
import {
  AGENTS_COLLECTION_NAME,
  AgentDocumentCollections,
  ChangeSourceType,
  ApproveDenyReason,
} from '@ag-common-lib/public-api';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';

@Injectable({
  providedIn: 'root',
})
export class AgentApproveDenyReasonsService {
  public readonly fsDao: CommonFireStoreDao<ApproveDenyReason>;
  private readonly agentCollectionPath = AGENTS_COLLECTION_NAME;
  private readonly associationCollectionPath = AgentDocumentCollections.approveDenyReason;

  constructor(
    @Inject(FIREBASE_APP) fireBaseApp: FirebaseApp,
    private toastrService: ToastrService,
  ) {
    this.fsDao = new CommonFireStoreDao<ApproveDenyReason>(fireBaseApp, null, null);
  }

  public getList(agentId: string, qp: QueryParam[] = []) {
    const table = this.getCollectionPath(agentId);

    return this.fsDao.getList(table, qp);
  }

  public getAll(agentId: string): Promise<ApproveDenyReason[]> {
    const table = this.getCollectionPath(agentId);

    return this.fsDao.getAll(table);
  }

  public create(agentId: string, data: ApproveDenyReason, silent = false, action: ChangeSourceType | null = null) {
    const table = this.getCollectionPath(agentId);
    Object.assign(data, {
      [BaseModelKeys.actionName]: action,
    });

    return this.fsDao
      .create(data, table)
      .then(response => {
        !silent && this.toastrService.success('Agent Status Activity Successfully Created!');
        return response;
      })

      .catch(e => {
        console.log('e', e);
      });
  }

  public update(
    agentId: string,
    documentId: any,
    updates: Partial<ApproveDenyReason>,
    silent = false,
    action: ChangeSourceType | null = null,
  ) {
    const table = this.getCollectionPath(agentId);
    Object.assign(updates, {
      [BaseModelKeys.actionName]: action,
    });

    return this.fsDao
      .updateFields(updates, documentId, table)
      .then(response => {
        !silent && this.toastrService.success('Agent Status Activity Successfully Updated!');
        return response;
      })

      .catch(e => {
        console.log('e', e);
      });
  }

  public delete(agentId: string, documentId: any, action: ChangeSourceType) {
    const table = this.getCollectionPath(agentId);

    return this.fsDao.delete(documentId, table, action).then(response => {
      this.toastrService.success('Agent ApproveDenyReason Removed!');
      return response;
    });
  }

  private getCollectionPath(agentId: string) {
    return [this.agentCollectionPath, agentId, this.associationCollectionPath].join('/');
  }
}
